var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-middle"},[_c('div',{staticClass:"tipo-user d-middle-center mr-2"},[_c('img',{staticClass:"obj-cover rounded-circle border",staticStyle:{"width":"45px","height":"45px"},attrs:{"src":_vm.grupo.imagen,"alt":""}})]),_c('div',[_c('p',{staticClass:"f-17 f-500"},[_vm._v(_vm._s(_vm.grupo.nombre))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }